export default "__VITE_ASSET__CrVOPWYY__"